{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".ProductS_slid");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.6,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1290: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Customer_slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          loop: true,
          speed: 1000,
          autoplay: {
            delay: 1000,
            disableOnInteraction: false,
          },
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Colections_slider");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const swiperWrapper = document.querySelector(
      ".brading_slids .swiper-wrapper"
    );
    const slides = swiperWrapper.querySelectorAll(".swiper-slide");
    const originalSlides = Array.from(slides);
    const duplicateCount = 1;
    for (let i = 0; i < duplicateCount; i++) {
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        swiperWrapper.appendChild(clone);
      });
    }
    var swiper = new Swiper(".brading_slids", {
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 60,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 2000,
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".Banner_slider", {
      parallax: true,
      autoHeight: true,
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      mousewheelControl: 1,
      effect: "slide",
      pagination: {
        paginationClickable: true,
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        150: {
          speed: 1000,
        },
        576: {
          speed: 1300,
        },
      },
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".logo_rows");
    const boxes = container.querySelectorAll(".LOGO_WRP");
    boxes.forEach((box) => {
      const clone = box.cloneNode(true);
      container.appendChild(clone);
    });
    const scrollDistance = container.scrollWidth / 2;
    let animation = gsap.to(container, {
      x: -scrollDistance,
      duration: 15,
      ease: "linear",
      repeat: -1,
    });
    container.addEventListener("mouseenter", () => animation.pause());
    container.addEventListener("mouseleave", () => animation.resume());
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper(".Detailing_slides", {
      direction: "horizontal",
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        150: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        576: {
          spaceBetween: 10,
          slidesPerView: 2,
        },
        769: {
          spaceBetween: 10,
          slidesPerView: 2.6,
        },
        1025: {
          spaceBetween: 10,
          slidesPerView: 3,
        },
      },
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Recmd-sliders");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          speed: 1000,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 1.2,
              spaceBetween: 15,
            },
            769: {
              slidesPerView: 1.4,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 2,
              spaceBetween: 30,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
